export class KeyRequest{ 
    idEmerges: number;
    datetimeExpiration: Date;
}